import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';

interface CollectionCardProps {
  collection: {
    id: number;
    name: string;
    description: string;
    productCount: number;
  };
}

export function CollectionCard({ collection }: CollectionCardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Demo.components.CollectionCard',
  });

  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardHeader>
        <CardTitle className="text-lg">{collection.name}</CardTitle>
        <CardDescription>{collection.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            {collection.productCount} {t('products')}
          </span>

          <Button asChild variant="ghost" size="sm" className="gap-1">
            <Link to="">
              Ver coleção
              <ArrowRight className="h-3 w-3" />
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
